import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SmsLayer from "../../components/message/SmsLayer";

const SmsPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="SMS" />
        <SmsLayer />
      </MasterLayout>
    </>
  );
};

export default SmsPage;
